/**
 * Weirwood
 * Copyright 2019 Baidu Inc. All rights reserved.
 *
 * @file try/catch 插件
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */
import { __assign } from "tslib";
import { getGlobal } from '../utils/global';
import { fill } from '../utils/fill';
import { wrapTimerFn } from '../utils/wrapper';
var global = getGlobal();
var TryCatchPlugin = /** @class */ (function () {
    function TryCatchPlugin(options) {
        this.name = TryCatchPlugin.id;
        this.options = __assign({ active: true }, options);
    }
    TryCatchPlugin.prototype.setupOnce = function (client) {
        this.client = client;
        if (this.options.active) {
            // 使用 try/catch 封装 timer 和事件回调函数，重新抛出异常，拿到 stack 堆栈信息
            fill(global, 'setTimeout', wrapTimerFn, this.client._wrappedBuiltIns);
        }
    };
    TryCatchPlugin.id = 'trycatch';
    return TryCatchPlugin;
}());
export { TryCatchPlugin };
//# sourceMappingURL=TryCatch.js.map